import request from "@/utils/request";

export function getBizStatByDistrict(projectId: string) {
  return request({
    url: "/baseinfo/teacherBizStat/byDistrict",
    method: "get",
    params: { projectId }
  });
}

export function getBizStatBySchool(projectId: string) {
  return request({
    url: "/baseinfo/teacherBizStat/bySchool",
    method: "get",
    params: { projectId }
  });
}
